Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlReset = void 0;
exports.htmlReset = {
  html: {
    lineHeight: '1.15',
    WebkitTextSizeAdjust: '100%'
  },
  body: {
    margin: 0
  }
};